export default "__VITE_ASSET__DuJG0gwU__"